import React from "react";
import { ReactTyped } from "react-typed";
 
import {
  Homecontent,
  Content,
  Button,
  RightButton,
  Text,
  TextHobbies,
  ImageContainer,
  Image
} from "./Styles";
 
function Home(){

    return (
      <section>
        <Homecontent>
          <Content >
           <Text> Hello,I am <span className="span"> Vembarasan </span> Nagarajan 👋🏻</Text>
           <Text>👨‍💻
           <ReactTyped style={{ fontSize:28, color:"grey"}} strings={[
            "Lead Software Engineer - Full Stack JavaScript Developer",
            "Data Sciences",
            "Entrepreneur",
            "I am glad you are glancing my portfolio.!"
            ]}
            typeSpeed={75}
            backSpeed={75} 
            />
            </Text>
            <TextHobbies> I enjoy reading books and listening to music.🎧📚</TextHobbies>
            <Button as="a"
             href="https://www.linkedin.com/in/vembarasan-nagarajan-he-him-09797b37/"
             target="_blank"
             rel="noopener"
             primary>Hire Me</Button> 
            <RightButton as="a"
             href="https://github.com/vembarasugn"
             target="_blank"
             rel="noopener"
             >GitHub</RightButton> 
          </Content>
          <ImageContainer>
            <Image/>
          </ImageContainer>
        </Homecontent>
    </section> 
  )
}
           
export default Home;
